export default __webpack_public_path__ + "media/plus/plus-unlimited-23af4e70.png";